import { render, staticRenderFns } from "./RIGrossPremStats.vue?vue&type=template&id=ce5b4d02&"
import script from "./RIGrossPremStats.vue?vue&type=script&lang=js&"
export * from "./RIGrossPremStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports